import  React, { useState } from 'react';
import Loader from '../../components/ui/Loader/Loader';
import Status from '../../components/ui/Status';

const GroupDetail =(props)=>{
    const [selectAllIAM, setSelectAllIAM] = useState(false);
    const [selectedIAMLicenses, setSelectedIAMLicenses] = useState({});
     const handleSelectAllIAM = (event) => {
        const isChecked = event.target.checked;
        setSelectAllIAM(isChecked);
        const updatedSelections = {};
        props.groupDetail.iam_licence.forEach((_, index) => {
            updatedSelections[index] = isChecked;
        });
        setSelectedIAMLicenses(updatedSelections);
    };
    const handleIAMCheckboxChange = (index) => {
        const updatedSelections = { ...selectedIAMLicenses, [index]: !selectedIAMLicenses[index] };
        setSelectedIAMLicenses(updatedSelections);
        if (!updatedSelections[index]) {
            setSelectAllIAM(false);
        } else {
            const allSelected = Object.values(updatedSelections).every(Boolean);
            setSelectAllIAM(allSelected);
        }
    };
     return (
          props.detail_loading ? <Loader /> : 
            <section className="item_view_container bg-white">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                        <div className='d-flex align-items-center gap-2'>
                            <button className="nav-link active" id="details-tab" data-bs-toggle="tab"
                                data-bs-target="#details" type="button" role="tab" aria-controls="details"
                                aria-selected="true">Details
                            </button>
                        </div>
                    </li>
                </ul>
                <div className="tab-content" id="myTabContent">
                    <div className="tab-pane show active" id="details" role="tabpanel" aria-labelledby="details-tab">
                        <div className="tab_content_header">
                            <div className="tab_content_wrapper">
                                <span className="content_heading">Detail</span>
                            </div>
                            </div>
                        {/* <div className="tab_content_header">
                            <div className="tab_content_wrapper">
                                <span className="content_heading">Detail</span>
                            </div>
                            <table className="table table-hover table-bordered table-responsive bg-white my-2">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "25%" }}>Group Name</td>
                                        <th>{props.groupDetail.group_name || '-'}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "25%" }}>Group ID</td>
                                        <th>{props.groupDetail.master?.tap_master_id || '-'}</th>
                                    </tr>
                                </tbody>
                            </table>
                             <div className='card'>
                                 <div className='card-body'>
                                     <div className="tab_content_wrapper mt-1"> <span className="content_heading">IAM License</span></div>
                                     <div className="table-responsive mt-2">
                                         <table className="table table-bordered table-sm">
                                             <thead className="table-secondary">
                                                 <tr>
                                                     <th className='text-center' style={{ width: "3%" }}> <input
                                                         type="checkbox"
                                                         className="form-check-input"
                                                     /></th>
                                                     <th style={{ width: "15%" }}>License Name</th>
                                                     <th style={{ width: "15%" }}>Status</th>
                                                     <th style={{ width: "10%" }}>Expiry Date</th>
                                                 </tr>
                                             </thead>
                                             <tbody>
                                                 {props.groupDetail.iam_licence.map((licence, index) => (
                                             <tr key={index}>
                                                 <td className='text-center'>
                                                     <input
                                                         type="checkbox"
                                                         className="form-check-input"
                                                         checked={selectedIAMLicenses[index] || false}
                                                         onChange={() => handleIAMCheckboxChange(index)}
                                                     />
                                                 </td>
                                                 <td>{licence.name}</td>
                                                 <td>
                                                     {licence ? (
                                                         <Status color={licence.status_color_code}>
                                                             {licence.status_text}
                                                         </Status>
                                                     ) : '-'}
                                                 </td>
                                                 <td>
                                                     {licence ? (
                                                         licence.licence_to_display
                                                     ) : '-'}
                                                 </td>
                                             </tr>
                                         ))}
                                                 <tr>
                                                     <td className='text-center'>
                                                         <input
                                                             type="checkbox"
                                                             className="form-check-input"
                                                         />
                                                     </td>
                                                     <td>
                                                         Asset Rental Module
                                                     </td>
                                                     <td>
                                                         {props.groupDetail.iam_licence ? (
                                                             <Status color={props.groupDetail.iam_licence.status_color_code}>
                                                                 {props.groupDetail.iam_licence.status_text}
                                                             </Status>
                                                         ) : '-'}
                                                     </td>
                                                     <td>
                                                         {props.groupDetail.iam_licence ? (
                                                             props.groupDetail.iam_licence.licence_to_display
                                                         ) : '-'}
                                                     </td>
                                                 </tr>
                                                 <tr>
                                                     <td className='text-center'>
                                                         <input
                                                             type="checkbox"
                                                             className="form-check-input"
                                                         />
                                                     </td>
                                                     <td>
                                                         -
                                                     </td>
                                                     <td>
                                                         {props.groupDetail.iam_licence ? (
                                                             <Status color={props.groupDetail.iam_licence.status_color_code}>
                                                                 {props.groupDetail.iam_licence.status_text}
                                                             </Status>
                                                         ) : '-'}
                                                     </td>
                                                     <td>
                                                         {props.groupDetail.iam_licence ? (
                                                             props.groupDetail.iam_licence.licence_to_display
                                                         ) : '-'}
                                                     </td>
                                                 </tr>
                                                 <tr>
                                                     <td className='text-center'>
                                                         <input
                                                             type="checkbox"
                                                             className="form-check-input"
                                                         />
                                                     </td>
                                                     <td>
                                                         Hetronic
                                                     </td>
                                                     <td>
                                                         {props.groupDetail.iam_licence ? (
                                                             <Status color={props.groupDetail.iam_licence.status_color_code}>
                                                                 {props.groupDetail.iam_licence.status_text}
                                                             </Status>
                                                         ) : '-'}
                                                     </td>
                                                     <td>
                                                         {props.groupDetail.iam_licence ? (
                                                             props.groupDetail.iam_licence.licence_to_display
                                                         ) : '-'}
                                                     </td>
                                                 </tr>
                                             </tbody>
                                         </table>
                                     </div>
                                     <div className="tab_content_wrapper">
                                         <span className="content_heading"> IAM Count</span>
                                     </div>
                                     <table className="table table-hover table-bordered table-responsive bg-white my-2">
                                         <tbody>
                                             <tr>
                                                 <td style={{ width: "25%" }}>Asset</td>
                                                 <th>{props.groupDetail.iam_licence && props.groupDetail.iam_licence.current_activity ? <span>{props.groupDetail.iam_licence.current_activity.asset_count} / {props.groupDetail.iam_licence.max_asset}</span> : ""}</th>
                                             </tr>
                                             <tr>
                                                 <td style={{ width: "25%" }}>User</td>
                                                 <th>{props.groupDetail.iam_licence && props.groupDetail.iam_licence.current_activity ? <span>{props.groupDetail.iam_licence.current_activity.user_count} / {props.groupDetail.iam_licence.max_user}</span > : ""}</th>
                                             </tr>
                                             <tr>
                                                 <td style={{ width: "25%" }}>Site</td>
                                                 <th>{props.groupDetail.iam_licence && props.groupDetail.iam_licence.current_activity ? <span>{props.groupDetail.iam_licence.current_activity.site_count} / {props.groupDetail.iam_licence.max_site}</span> : ""}</th>
                                             </tr>
                                         </tbody>
                                     </table>
                                 </div>
                             </div>
                           <div className='card mt-2'>
                                 <div className='card-body'>
                            <div className="tab_content_wrapper mt-1">
                                <span className="content_heading">HRM License</span>
                            </div>
                            <div className="table-responsive mt-2">
                                <table className="table table-bordered table-sm">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th className='text-center' style={{ width: "3%" }}> <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                /></th>
                                            <th style={{ width: "15%" }}>License Name</th>
                                            <th style={{ width: "15%" }}>Status</th>
                                            <th style={{ width: "10%" }}>Expiry Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='text-center'>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                />
                                            </td>
                                            <td>
                                                HRM
                                            </td>
                                            <td>
                                                {props.groupDetail.hrm_licence ? (
                                                    <Status color={props.groupDetail.hrm_licence.status_color_code}>
                                                        {props.groupDetail.hrm_licence.status_text}
                                                    </Status>
                                                ) : '-'}
                                            </td>
                                            <td>
                                                {props.groupDetail.hrm_licence ? (
                                                    props.groupDetail.hrm_licence.active_till_display
                                                ) : '-'}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="tab_content_wrapper">
                                <span className="content_heading">HRM Count</span>
                            </div>
                            <table className="table table-hover table-bordered table-responsive bg-white my-2">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "25%" }}>Employee</td>
                                        <th>{props.groupDetail.hrm_licence ? <span>{props.groupDetail.hrm_licence.current_users} / {props.groupDetail.hrm_licence.max_users}</span> : ""}</th>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                            </div>
                             <div className='card mt-2'>
                                 <div className='card-body'>
                            <div className="tab_content_wrapper mt-1"> <span className="content_heading">ISC License</span></div>
                            <div className="table-responsive mt-2">
                                <table className="table table-bordered table-sm">
                                    <thead className="table-secondary">
                                        <tr>
                                            <th className='text-center' style={{ width: "3%" }}> <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                /></th>
                                            <th style={{ width: "15%" }}>License Name</th>
                                            <th style={{ width: "15%" }}>Status</th>
                                            <th style={{ width: "10%" }}>Expiry Date</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td className='text-center'>
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                />
                                            </td>
                                            <td>
                                                ISC
                                            </td>
                                            <td>
                                                {props.groupDetail.isc_licence ? (
                                                    <Status color={props.groupDetail.isc_licence.status_color_code}>
                                                        {props.groupDetail.isc_licence.status_text}
                                                    </Status>
                                                ) : '-'}
                                            </td>
                                            <td>
                                                {props.groupDetail.isc_licence ? (
                                                    props.groupDetail.isc_licence.active_till_display
                                                ) : '-'}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="tab_content_wrapper">
                                <span className="content_heading">ISC Count</span>
                            </div>
                            <table className="table table-hover table-bordered table-responsive bg-white my-2">
                                <tbody>
                                    <tr>
                                        <td style={{ width: "25%" }}>Warehouse</td>
                                        <th>{props.groupDetail.isc_licence ? <span>{props.groupDetail.isc_licence.current_warehouse} / {props.groupDetail.isc_licence.max_warehouse}</span> : ""}</th>
                                    </tr>
                                    <tr>
                                        <td style={{ width: "25%" }}>Item</td>
                                        <th>{props.groupDetail.isc_licence ? <span>{props.groupDetail.isc_licence.current_items} / {props.groupDetail.isc_licence.max_items}</span> : ""}</th>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>
    );
}
export default GroupDetail;
